import { useMemo } from 'react';
import type {
  SizingProps,
  SpaceProps,
  LayoutProps,
  BoxShadowProps,
  BorderProps,
  BackgroundProps,
} from '@elliemae/ds-legacy-system';
import { xstyledKeys } from './constants.js';

export interface XstyledProps
  extends SpaceProps,
    SizingProps,
    LayoutProps,
    BoxShadowProps,
    BorderProps,
    BackgroundProps {}

type PropsWithXstyled<T> = T & XstyledProps;

export const useGetXstyledProps = <T,>(props: PropsWithXstyled<T>): XstyledProps => {
  const componentXstyledProps = useMemo(() => {
    const xstyledPropsObject: Record<string, unknown> = {};
    Object.entries(props).forEach(([key, value]) => {
      if (key in xstyledKeys) {
        xstyledPropsObject[key] = value;
      }
    });
    return xstyledPropsObject;
  }, [props]);

  return componentXstyledProps as XstyledProps;
};
